import React from 'react';

import { InjectedIntl } from 'react-intl';

import messages from './description.i18n';
import * as styles from './styles';

type DescriptionProps = {
  description?: string;
  intl: InjectedIntl;
};

function Description(props: DescriptionProps): JSX.Element | null {
  const { description, intl } = props;

  if (!description) {
    return null;
  }

  return (
    <styles.TableSection>
      <styles.TableHeading>
        {intl.formatMessage(messages.header)}
      </styles.TableHeading>
      <styles.TableRow>{description}</styles.TableRow>
    </styles.TableSection>
  );
}

export default React.memo(Description);
